import { ReactElement } from 'react'

import { BreadcrumbList, WithContext, ListItem } from 'schema-dts'

import { SETTINGS_GENERAL } from '@/config/settings.general'

interface Props {
    links: { title: string; href?: string }[]
}

export default function BreadcrumbsGoogleSchema({
    links,
}: Props): ReactElement {
    const itemListElement: ListItem[] = links.map((link, index) => ({
        position: index + 1,
        '@type': 'ListItem',
        name: link.title,
        ...(link.href
            ? { item: `${SETTINGS_GENERAL.SITE_URL}${link.href}` }
            : undefined),
    }))

    const breadcrumbs: WithContext<BreadcrumbList> = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
    }

    return (
        <script
            type={'application/ld+json'}
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(breadcrumbs),
            }}
        />
    )
}
